import { dapBffApiV2 } from '@dap/bff/data-access';

const sanityApiV2 = dapBffApiV2.injectEndpoints({
  endpoints: (build) => ({
    getReadToken: build.query<{ token: string | false }, void>({
      query: () => ({
        url: '/sanity/getReadToken',
        method: 'GET',
      }),
      transformResponse: (response: { data: { token: string | false } }) => {
        return response.data;
      },
    }),
  }),

  overrideExisting: false,
});

export const { useGetReadTokenQuery } = sanityApiV2;
